import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Input as AInput } from "antd";
const { TextArea } = AInput;
import styles from "./index.scss";

const Input = function (props, ref) {
	const handleOnChange = (event) => {
		const value = event.target.value;
		const { onChange, name } = props;
		onChange && onChange({ value, name, event });
	};

	const {
		className,
		inputClassName,
		labelClassName,
		type,
		label,
		readOnly,
		multi,
		value,
		accept,
		error,
		helperText,
		labelSuffix,
		required,
		..._props
	} = props;

	const _className = cx(styles.container, className);

	const _inputClassName = cx(
		{
			[styles.readonly]: readOnly,
			[styles.hasError]: error,
		},
		inputClassName
	);

	const _labelClassName = cx(styles.label, labelClassName, {
		[styles.required]: required,
	});
	const _helperTextClassName = cx(styles.helperText, {
		[styles.error]: error,
	});

	return (
		<div className={_className}>
			{label ? (
				<label className={_labelClassName}>
					{label}{" "}
					<span className={styles.labelSuffix}>{labelSuffix}</span>
				</label>
			) : null}

			{multi ? (
				<TextArea {..._props} ref={ref} />
			) : type == "password" ? (
				<AInput.Password
					{..._props}
					className={_inputClassName}
					value={value}
					disabled={readOnly}
					type={type}
					accept={accept}
					ref={ref}
					onChange={handleOnChange}
				/>
			) : (
				<AInput
					{..._props}
					className={_inputClassName}
					value={value}
					disabled={readOnly}
					type={type}
					accept={accept}
					ref={ref}
					onChange={handleOnChange}
				/>
			)}

			{helperText && helperText.length ? (
				<label className={_helperTextClassName}>{helperText}</label>
			) : null}
		</div>
	);
};

Input.propTypes = {
	name: PropTypes.string,
	accept: PropTypes.string,
	type: PropTypes.oneOf([
		"text",
		"number",
		"password",
		"file",
		"date",
		"email",
	]),
	label: PropTypes.string,
	placeholder: PropTypes.string,
	defaultValue: PropTypes.string,
	readOnly: PropTypes.bool,
	autoFocus: PropTypes.bool,
	required: PropTypes.bool,
	maxLength: PropTypes.number,
	onChange: PropTypes.func,
	onBlur: PropTypes.func,
	onFocus: PropTypes.func,
	onKeyDown: PropTypes.func,
	/* Will be applied to container */
	className: PropTypes.string,
	/* Will be applied to underlying input/textarea tag */
	inputClassName: PropTypes.string,
	/* Will be applied to label */
	labelClassName: PropTypes.string,
	labelSuffix: PropTypes.any,
	/* Renders a textarea if true */
	multi: PropTypes.bool,
	/* Value */
	value: PropTypes.string,
	error: PropTypes.bool,
	helperText: PropTypes.string,
};

Input.defaultProps = {
	className: "",
	inputClassName: "",
	labelClassName: "",
	type: "text",
	label: "",
	placeholder: "",
	readOnly: false,
	multi: false,
};

export default React.forwardRef((props, ref) => Input(props, ref));
